// The cart's Checkout button (sections/cart-template.liquid) calls testme().
// California excise tax is added at checkout by Magical Fees, so all that is
// left to do here is make sure the acknowledgement box is ticked.
function testme(e) {
  if (e) e.preventDefault();
  var terms = document.getElementById('aterms');
  if (!terms || !terms.checked) {
    alert('You should accept our terms and conditions first.');
    return false;
  }
  window.location.href = '/checkout';
  return false;
}
